import { DB, SQLBatchTuple } from ".";
import log from "../log";

const insert_sql =
    "insert or replace into t_emoticon(id, url, ctime) values(?, ?, ?)"
export async function emoticon_insert(
    db: DB,
    emoticons: Emoticon[]
): Promise<{ error: any }> {
    let err: any = null;
    let insertCnt: number = 0;
    let updateCnt: number = 0;
    const n = emoticons.length;
    const commands: SQLBatchTuple[] = []
    for (let i = 0; i < n; i++) {
        const emoticon = emoticons[i]
        const parms = [emoticon.id, emoticon.url, emoticon.ctime];
        commands.push([insert_sql, parms])
        // const r = await db.Execute(insert_sql, parms);
        // if (r.error) {
        //     err = r.error;
        //     continue;
        // }
        // if (r.insertId > 0) {
        //     insertCnt++;
        // }
        // if (r.rowsAffected > 0) {
        //     updateCnt += r.rowsAffected;
        // }
    }
    const r = await db.BatchExecute(commands);
    log.info("emoticon_insert succ", "插入:", r.rowsAffected, "修改:", updateCnt);
    return { error: err };
}

export async function qry_emoticons(db: DB, skip: number, pageSize: number): Promise<{ error?: any, emoticons?: Emoticon[] }> {
    const sql = `SELECT * FROM t_emoticon ORDER BY ctime DESC LIMIT ?, ?`

    const r = await db.Query(sql, [skip, pageSize])
    if (r.data && r.data.length > 0) {
        return { emoticons: r.data }
    }
    return { error: r.error }
}

export async function del_emoticon(db: DB, ids: string[]): Promise<{ error?: any }> {
    let err: any = null;
    const n = ids.length;
    const commands: SQLBatchTuple[] = []
    const sql = `DELETE FROM t_emoticon WHERE id = ?`
    for (let i = 0; i < n; i++) {
        commands.push([sql, [ids[i]]])
        // const r = await db.Execute(sql, [])
        // if (r.error) {
        //     err = r.error;
        //     continue;
        // }
    }
    const r = await db.BatchExecute(commands)
    return { error: err }
}


export type Emoticon = {
    id: string,
    url: string,
    ctime: number
}